import fromPairs from 'lodash/fromPairs';
import moment from 'moment';
import { assessmentsService } from 'src/config/rootService';

import {
    Assessment,
    AssessmentsState,
    AssessmentType,
    LegacyWho5SubmitData,
    MappedAnswers,
    MappedScores,
} from '../models/assessments';

const defaultState: AssessmentsState = {
    assessments: {},
    scores: {
        [AssessmentType.Who5]: undefined,
        [AssessmentType.EmploymentHealth]: undefined,
        [AssessmentType.Phq2]: undefined,
        [AssessmentType.Phq8]: undefined,
        [AssessmentType.Gad2]: undefined,
        [AssessmentType.Gad7]: undefined,
    },
    mostRecentAssessmentDate: '',
};

export const assessments = {
    state: defaultState,
    reducers: {
        saveScores: (state: AssessmentsState, nextScores: MappedScores) => {
            const newSate = {
                ...state,
                scores: {
                    ...state.scores,
                    ...nextScores,
                },
            };

            return newSate;
        },
        saveAssessmentData: (state: AssessmentsState, fetchedAssessments: [Assessment]) => {
            const newState: AssessmentsState = {
                ...state,
                assessments: fromPairs(
                    fetchedAssessments.map(assessment => [assessment.name, assessment]),
                ),
            };

            return newState;
        },
        saveMostRecentAssessmentDate: (state: AssessmentsState, date: string) => {
            const newState: AssessmentsState = {
                ...state,
                mostRecentAssessmentDate: date,
            };

            return newState;
        },
        'authentication/logout': () => {
            return defaultState;
        },
    },
    effects: dispatch => ({
        async fetchAssessments(): Promise<void> {
            const fetchAssessments = await assessmentsService.fetchAssessments();

            dispatch.assessments.saveAssessmentData(fetchAssessments);
        },
        async submitAssessments({
            answers,
            assessmentFlowUuid,
        }: {
            answers: MappedAnswers;
            assessmentFlowUuid: string;
        }): Promise<Record<string, number>> {
            const scores = await assessmentsService.submitAssessments(answers, assessmentFlowUuid);

            dispatch.assessments.saveScores(scores);
            dispatch.assessments.saveMostRecentAssessmentDate(moment().toISOString());

            return scores;
        },
        // this is required for who5 survey in legacy programs
        async submitLegacyWho5Assessment(data: LegacyWho5SubmitData): Promise<void> {
            await assessmentsService.submitLegacyWho5Assessment(data);
        },
        async fetchLatestScores(): Promise<Record<string, number>> {
            const { scores, date } = await assessmentsService.fetchScores();

            dispatch.assessments.saveScores(scores);
            dispatch.assessments.saveMostRecentAssessmentDate(date);

            return scores;
        },
    }),
};
